import React, { useEffect, useState } from "react";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";
import { DefaultSelectFilter } from "../../../../components/inputs/defaultSelectFilter";
import CommonModal from "../../../../components/modals/commonModel";
import toast from "react-hot-toast";
import {
  deleteCategory,
  getCategoryList,
} from "../../../../../services/workspace/inventory.service";
import PaginationComponent from "../../../../components/table/tablePagination";
import ManageSalaryForm from "../../../../components/forms/payrole/manageSalaryForm";
import SalaryReportTable from "./components/table";
import {
  deleteSalaryReport,
  getSalaryReport,
} from "../../../../../services/workspace/payroll.service";

const items = [
  { label: "Home", path: "/" },
  { label: "Payroll", path: "/payroll" },
  { label: "Salary Report", path: "" },
];

const tableHeading = [
  "Employee Name",
  "Date of Joining",
  "Department",
  "Designation",
  "Designation",
  "Total Days",
  "Present",
  "Absent",
  "Absent",
  "Holiday/Friday",
  "Transport Allowance",
  "Additional Allowance",
  "Net Salary",
];

function SalaryReport() {
  const [selectedValue, setSelectedValue] = useState("desc");

  // const [selectedOption, setSelectedOption] = useState(""); // Default value as empty string
  // const [isError, setIsError] = useState(false);
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [totalData, setTotalData] = useState(0);

  const { limit } = useState(10);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);

  const fetchData = () => {
    setLoading(true);
    getSalaryReport({
      search,
      page: search ? 1 : currentPage,
      limit,
      order_by: "created_at",
      order_type: selectedValue,
    })
      .then((response) => {
        setLoading(false);
        setTableData(response.data || []);
        setTotalData(response.total || 0);
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Failed to fetch designation data!");
        console.error(error);
      });
  };

  // Debounce search functionality for optimized performance
  useEffect(() => {
    const timer = setTimeout(
      () => {
        fetchData();
      },
      search ? 500 : 0
    ); // Adjust debounce time as needed

    return () => clearTimeout(timer);
  }, [search, currentPage, limit, selectedValue]);

  // Function to handle modal toggle
  const toggleModal = (id = "") => {
    if (id) { 
      setSelectedId(id);
      setIsModalOpen(!isModalOpen);
    } else {
      setIsModalOpen(!isModalOpen);
    }
  };

  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const onConfirm = () => { 
    deleteSalaryReport(selectedId)
      .then((response) => {
        fetchData();
        toast.success("Category deleted successfully!");
      })
      .catch((error) => {
        toast.error(
          "This item cannot be deleted because it is referenced in other records. Please remove any associated entries in related tables before retrying."
        );
      });

    setSelectedId(false);
    setIsOpen(false);
  };

  const handleStatus = (id) => {
    setSelectedId(id);
    setIsOpen(true);
  };

  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader
        breadcrumbs={items}
        isSearch={true}
        onSearchChange={(e) => setSearch(e.target.value)}
        isFilter={false}
        buttons={false}
      />

      {isModalOpen && (
        <CommonModal
          modalSize="sm"
          headerTitle={selectedId ? "Edit " : "Add "}
          onClose={() => {
            setSelectedId("");
            fetchData();
            setIsModalOpen(false);
          }}
          onSave={() => {}}
          show={isModalOpen}
        >
          <ManageSalaryForm
            isModal={true}
            onClose={() => {
              setSelectedId("");
              fetchData();
              setIsModalOpen(false);
            }}
            id={selectedId ? selectedId : ""}
          />
        </CommonModal>
      )}

      <div className=" flex flex-col ">
        <div className="flex flex-row gap-2 p-4 text-theme font-bold items-center bg-white">
          <DefaultSelectFilter
            className="bg-light hover:bg-bghoverlight px-2 rounded-md flex flex-row gap-1"
            label="Sort By"
            options={[
              { label: "Newest First", value: "desc" },
              { label: "Oldest First", value: "asc" },
            ]}
            name={"filter"}
            onChange={handleSelectChange}
            // error={isError}
            errorMsg="Please select an option"
          />
        </div>

        <div className="flex flex-col gap-2">
          <SalaryReportTable
            tableHeading={tableHeading}
            tableData={tableData}
            onClick={onclick}
            handleStatus={handleStatus}
            onConfirm={onConfirm}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            loading={loading}
            toggleModal={toggleModal}
          />
          <PaginationComponent
            itemPerPage={limit}
            currentPage={currentPage}
            totalItems={totalData}
            paginate={setCurrentPage}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
}

export default SalaryReport;
